<template lang="pug">
div(:class="{ 'relative': $storyblok.isEditing }")
    CarouselProduct(
        v-if="!$storyblok.isEditing && type"
        :productType="type"
    )
    div(
        v-else-if="$storyblok.isEditing"
        class="flex justify-center items-center h-64 bg-gray-light"
    )
        p(class="text-center capitalize")
            | {{ type }} Products Carousel

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )

</template>

<script>
import CarouselProduct from '@/components/carousel/product/'

export default {
    name: 'RecommendationsWidget',
    components: {
        CarouselProduct,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        type() {
            return this.data.type?.toLowerCase() || null
        },
    },
}
</script>
